<mat-card class="datesSummary">
    <mat-card-header>
        <mat-card-title>
            <h4>
                {{
                    "dashboardBizzDev.datesSummary.title.shortLabel" | translate
                }}
                <app-tooltip
                    text="{{
                        'dashboardBizzDev.datesSummary.title.summary'
                            | translate
                    }}"
                ></app-tooltip>
            </h4>
        </mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <ng-container *ngIf="isTestLaunched">
            <section>
                <table>
                    <tbody>
                        <tr>
                            <td class="labelDate">
                                {{
                                    "dashboardBizzDev.datesSummary.table.production.fullLabel"
                                        | translate
                                }}
                            </td>
                            <td>
                                <b>{{
                                    lastProdDeploymentDate
                                        | date: "dd/MM/yyyy HH:mm"
                                }}</b>
                            </td>
                        </tr>
                        <tr>
                            <td class="labelDate">
                                {{
                                    "dashboardBizzDev.datesSummary.table.tests.fullLabel"
                                        | translate
                                }}
                            </td>
                            <td>
                                <b>{{
                                    isTestLaunched.endTime
                                        | date: "dd/MM/yyyy HH:mm"
                                }}</b>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="3">
                                <hr />
                            </td>
                        </tr>
                        <tr>
                            <td class="labelDate">
                                {{
                                    "dashboardBizzDev.datesSummary.table.bbc2020.fullLabel"
                                        | translate
                                }}
                            </td>
                            <td>
                                <b>{{
                                    bbcImportDate | date: "dd/MM/yyyy HH:mm"
                                }}</b>
                            </td>
                        </tr>
                        <tr>
                            <td class="labelDate">
                                {{
                                    "dashboardBizzDev.datesSummary.table.sic.fullLabel"
                                        | translate
                                }}
                            </td>
                            <td>
                                <b>{{
                                    sicImportDate | date: "dd/MM/yyyy HH:mm"
                                }}</b>
                            </td>
                        </tr>
                        <tr>
                            <td class="labelDate">
                                {{
                                    "dashboardBizzDev.datesSummary.table.sicbxl.fullLabel"
                                        | translate
                                }}
                            </td>
                            <td>
                                <b>{{
                                    sicbxlImportDate | date: "dd/MM/yyyy HH:mm"
                                }}</b>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </section>
        </ng-container>
    </mat-card-content>
</mat-card>
